/* FIT — Shopify cart integration.
 * Wires the cart drawer to Shopify's AJAX Cart API.
 * Exposes window.FIT = { openCart, closeCart, addItem, checkout, refresh, addUpsell, addMagnetPads, addWarranty, addLifetime, addLoxxKit, addLoxxUpgrade }.
 * Upsell variant IDs are injected by layout/theme.liquid as window.FIT_UPSELLS (null when the product doesn't exist yet).
 * build: cart-total-refresh-20260812 — line-key change + totals always recompute after remove
 */
/* fit-atc-pixel-fix LIVE 2026-08-14T12:00Z */
/* fit-phantom-asset-fix 2026-08-14T11:50Z — strip ?v=504xx ghost theme URLs (404s after thrash) */

(function(){
  /* Run first: stop stale double-CDN injects that Clarity flags as JS errors */
  try { window.__fitShopGridFix = true; } catch (e0) {}
  try {
    if (!window.__fitAppendPatch) {
      window.__fitAppendPatch = true;
      var _ap = Node.prototype.appendChild;
      Node.prototype.appendChild = function (n) {
        try {
          if (n && n.tagName === 'SCRIPT' && n.src && String(n.src).indexOf('/cdn/cdn/') !== -1) {
            n.src = String(n.src).replace('/cdn/cdn/', '/cdn/');
          }
        } catch (eA) {}
        return _ap.apply(this, arguments);
      };
    }
  } catch (eP) {}

  /* Ghost theme asset versions (?v=504xx) 404 even when the file exists on the theme.
     Page-cache freezes them into HTML/JS after partial asset thrash. Strip to bare path. */
  try {
    if (!window.__fitPhantomAssetFix) {
      window.__fitPhantomAssetFix = true;
      function fitFixPhantomUrl(u) {
        if (!u || typeof u !== 'string') return u;
        if (/\/cdn\/shop\/t\/\d+\/assets\/[^"'?\s]+\?v=504\d+/i.test(u)) {
          return u.replace(/\?v=504\d+[^"'?\s]*/i, '');
        }
        return u;
      }
      function fitFixPhantomEl(el) {
        if (!el || !el.getAttribute) return;
        ['src', 'poster', 'data-src', 'data-yt-modal', 'href'].forEach(function (attr) {
          var v = el.getAttribute(attr);
          if (!v) return;
          var n = fitFixPhantomUrl(v);
          if (n !== v) {
            try { el.setAttribute(attr, n); } catch (eF) {}
          }
        });
      }
      function fitScanPhantom(root) {
        try {
          (root || document).querySelectorAll(
            'img[src*="v=504"],video[poster*="v=504"],source[src*="v=504"],button[data-yt-modal*="v=504"],a[href*="v=504"]'
          ).forEach(fitFixPhantomEl);
          // also catch without attribute selector quirks
          (root || document).querySelectorAll('#galleryVideos img, #pdpInbox img, .pdp-inbox img, .gal-vid img, video#galleryVid').forEach(fitFixPhantomEl);
        } catch (eS) {}
      }
      function fitRunPhantom() { fitScanPhantom(document); }
      window.__fitFixPhantomThemeAssets = fitRunPhantom;
      fitRunPhantom();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitRunPhantom);
      setTimeout(fitRunPhantom, 60);
      setTimeout(fitRunPhantom, 400);
      setTimeout(fitRunPhantom, 1500);
      try {
        var mo = new MutationObserver(function () { fitRunPhantom(); });
        if (document.documentElement) {
          mo.observe(document.documentElement, { childList: true, subtree: true });
          setTimeout(function () { try { mo.disconnect(); } catch (eD) {} }, 10000);
        }
      } catch (eM) {}
    }
  } catch (ePh) {}

  const state = { cart: null, busy: false };
  const UP = window.FIT_UPSELLS || {};

  async function refresh(){
    try {
      const r = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: '*/*' }
      });
      if (!r.ok) throw new Error('cart-js-' + r.status);
      state.cart = await r.json();
    } catch (e){
      try { console.warn('cart refresh', e); } catch (e1) {}
      if (!state.cart) state.cart = { items: [], total_price: 0, items_subtotal_price: 0, item_count: 0 };
    }
    render();
    return state.cart;
  }

  async function addItem(variantId, quantity = 1, properties = {}, opts){
    if (!variantId) return;
    await addItems([{ id: variantId, quantity, properties }], opts);
  }

  /**
   * Fire AddToCart to Meta + Shopify web pixels + gtag.
   * Ajax /cart/add.js does NOT always emit product_added_to_cart to Customer Events;
   * without this, Meta/Klaviyo can show ViewContent with zero ATC (seen 2026-08-14).
   * build: atc-pixel-fix-20260814
   */
  function trackAddToCart(addResponse, requestItems){
    try {
      var addedItems = [];
      if (addResponse && Array.isArray(addResponse.items)) addedItems = addResponse.items;
      else if (addResponse && addResponse.id) addedItems = [addResponse];
      if (!addedItems.length && state.cart && Array.isArray(state.cart.items) && requestItems && requestItems.length) {
        addedItems = state.cart.items.slice(-requestItems.length);
      }
      var ids = [];
      var contents = [];
      var value = 0;
      var currency = (state.cart && state.cart.currency) || 'USD';
      var cartLines = [];
      for (var i = 0; i < addedItems.length; i++) {
        var it = addedItems[i] || {};
        var vid = String(it.variant_id || it.id || '');
        var qty = Number(it.quantity || 1) || 1;
        var lineCents = Number(it.final_line_price != null ? it.final_line_price : (it.line_price != null ? it.line_price : (it.price || 0) * qty));
        var unitCents = Number(it.final_price != null ? it.final_price : (it.price || 0));
        if (vid) ids.push(vid);
        value += (lineCents || 0) / 100;
        contents.push({ id: vid, quantity: qty, item_price: unitCents / 100 });
        cartLines.push({
          quantity: qty,
          merchandise: {
            id: vid ? ('gid://shopify/ProductVariant/' + vid) : undefined,
            product: {
              id: it.product_id ? ('gid://shopify/Product/' + it.product_id) : undefined,
              title: it.product_title || it.title || ''
            },
            title: it.variant_title || it.title || '',
            price: {
              amount: (unitCents / 100).toFixed(2),
              currencyCode: currency
            }
          }
        });
      }
      if (!ids.length && requestItems && requestItems.length) {
        for (var j = 0; j < requestItems.length; j++) {
          var rid = String(requestItems[j].id || '');
          if (rid) ids.push(rid);
          contents.push({ id: rid, quantity: requestItems[j].quantity || 1 });
        }
      }
      // Meta / Facebook browser pixel (classic fbq if present)
      if (typeof window.fbq === 'function' && ids.length) {
        try {
          window.fbq('track', 'AddToCart', {
            content_ids: ids,
            content_type: 'product_group',
            contents: contents,
            value: Math.round(value * 100) / 100,
            currency: currency
          });
        } catch (eFb) {}
      }
      // Shopify Customer Events → Meta web pixel + other CE apps
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        try {
          var payload = {
            cartLine: cartLines[0] || { merchandise: { id: ids[0] ? ('gid://shopify/ProductVariant/' + ids[0]) : undefined } },
            cartLines: cartLines
          };
          Shopify.analytics.publish('product_added_to_cart', payload);
        } catch (ePub) {}
      }
      // Google
      if (typeof window.gtag === 'function') {
        try {
          window.gtag('event', 'add_to_cart', {
            currency: currency,
            value: Math.round(value * 100) / 100,
            items: ids.map(function (id, idx) {
              return { item_id: id, quantity: (contents[idx] && contents[idx].quantity) || 1 };
            })
          });
        } catch (eG) {}
      }
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        try {
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: { currency: currency, value: value, items: contents }
          });
        } catch (eDl) {}
      }
    } catch (eAll) {
      try { console.warn('FIT trackAddToCart', eAll); } catch (eW) {}
    }
  }

  /**
   * Batch add — one refresh (avoids race when ATC adds cover + LOXX + bundle).
   * opts.open defaults true (drawer). Pass { open: false } for direct checkout (no slide-out flash).
   */
  async function addItems(lines, opts){
    opts = opts || {};
    const shouldOpen = opts.open !== false;
    const items = (lines || [])
      .filter(l => l && l.id)
      .map(l => ({
        id: Number(l.id),
        quantity: l.quantity || 1,
        properties: l.properties || {}
      }));
    if (!items.length) throw new Error('no-items');
    let r;
    try {
      r = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
    } catch (netErr) {
      throw new Error('network');
    }
    if (!r.ok) {
      let detail = '';
      try { detail = await r.text(); } catch (e) {}
      const err = new Error('add-failed');
      err.status = r.status;
      err.detail = detail;
      throw err;
    }
    let addedPayload = null;
    try { addedPayload = await r.json(); } catch (eJ) { addedPayload = null; }
    try { await refresh(); } catch (e) { /* cart still added */ }
    // Pixel / CE ATC — must run before checkout navigation
    try { trackAddToCart(addedPayload, items); } catch (eT) {}
    // Re-attach Google click IDs to cart attributes after ATC (checkout attribution)
    try {
      if (typeof window.__fitPersistGoogleClickIds === 'function') window.__fitPersistGoogleClickIds();
      document.dispatchEvent(new CustomEvent('fit:cart-updated'));
    } catch (e) {}
    if (shouldOpen) {
      try { openCart(); } catch (e) { window.location.href = '/cart'; }
    } else {
      try { closeCart(); } catch (e0) {}
    }
  }

  /**
   * Change qty / remove. Prefer Shopify line-item key (unique when same variant ×2
   * with different properties). Fall back to 1-based line index.
   * Always re-render totals from the change response or a fresh /cart.js.
   */
  async function changeItem(line, quantity){
    const items = (state.cart && state.cart.items) || [];
    const item = items[line - 1] || null;
    // Shopify: { id: line_item_key, quantity } is more reliable than { line }
    const body = (item && item.key)
      ? { id: item.key, quantity: Number(quantity) }
      : { line: Number(line), quantity: Number(quantity) };
    let r;
    try {
      r = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
    } catch (netErr) {
      await refresh();
      throw new Error('network');
    }
    if (r.ok) {
      try {
        const cart = await r.json();
        // /cart/change.js returns the full cart — use it so totals match the server
        if (cart && typeof cart === 'object' && Array.isArray(cart.items)) {
          state.cart = cart;
          render();
          try { document.dispatchEvent(new CustomEvent('fit:cart-updated')); } catch (eD) {}
          return state.cart;
        }
      } catch (eJ) { /* fall through to refresh */ }
    }
    // Fallback: re-fetch /cart.js (never leave stale totals on screen)
    await refresh();
    try { document.dispatchEvent(new CustomEvent('fit:cart-updated')); } catch (eD2) {}
    return state.cart;
  }

  /* ── Ship progress STANDARD (cart + PDP + SSR) ─────────────────────────
   * Order today → In production (+2 biz days) → Ships on or before (+5 biz)
   * Fill stops at center of step 1 (16.666%). Same labels/dates everywhere.
   */
  function addBizDays(from, n){
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let left = n;
    while (left > 0){
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) left--;
    }
    return d;
  }
  function fmtShipDate(d){
    return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function shipProgressDates(){
    const now = new Date();
    return {
      today: fmtShipDate(now),
      production: fmtShipDate(addBizDays(now, 2)),
      shipBy: fmtShipDate(addBizDays(now, 5)),
      fillPct: 16.666
    };
  }
  /**
   * Paint a 3-step ship bar. Accepts:
   *  - root element containing .psp-fill / .psp-step / .psp-dot
   *  - or id prefix map via opts.ids = { fill, track, s1, s2, s3, step1, step2, step3, d1, d2, d3 }
   */
  function paintShipProgress(rootOrOpts){
    const dates = shipProgressDates();
    const fillPct = dates.fillPct;
    let fill, track, s1, s2, s3, step1, step2, step3, d1, d2, d3;
    if (rootOrOpts && rootOrOpts.nodeType === 1){
      const root = rootOrOpts;
      fill = root.querySelector('.psp-fill');
      track = root.querySelector('.psp-track');
      const steps = root.querySelectorAll('.psp-step');
      step1 = steps[0]; step2 = steps[1]; step3 = steps[2];
      s1 = step1 && step1.querySelector('span');
      s2 = step2 && step2.querySelector('span');
      s3 = step3 && step3.querySelector('span');
      const dots = root.querySelectorAll('.psp-dot');
      d1 = dots[0]; d2 = dots[1]; d3 = dots[2];
    } else {
      const ids = (rootOrOpts && rootOrOpts.ids) || {};
      fill = document.getElementById(ids.fill || 'cartProgBar');
      track = document.getElementById(ids.track || 'cartProgTrack')
        || document.querySelector(ids.trackSel || '#cartProgress .psp-track');
      s1 = document.getElementById(ids.s1 || 'cartPspStep1Txt');
      s2 = document.getElementById(ids.s2 || 'cartPspStep2Txt');
      s3 = document.getElementById(ids.s3 || 'cartPspStep3Txt');
      step1 = document.getElementById(ids.step1 || 'cartPspStep1');
      step2 = document.getElementById(ids.step2 || 'cartPspStep2');
      step3 = document.getElementById(ids.step3 || 'cartPspStep3');
      d1 = document.getElementById(ids.d1 || 'cartPspDot1');
      d2 = document.getElementById(ids.d2 || 'cartPspDot2');
      d3 = document.getElementById(ids.d3 || 'cartPspDot3');
    }
    if (fill) fill.style.width = fillPct + '%';
    if (track) track.setAttribute('aria-valuenow', String(Math.round(fillPct)));
    if (s1) s1.textContent = dates.today;
    if (s2) s2.textContent = dates.production;
    if (s3) s3.textContent = dates.shipBy;
    /* Lock step titles to cart standard (never “Ships by” / old copy) */
    try {
      var t1 = step1 && step1.querySelector('strong');
      var t2 = step2 && step2.querySelector('strong');
      var t3 = step3 && step3.querySelector('strong');
      if (t1) t1.textContent = 'Order today';
      if (t2) t2.textContent = 'In production';
      if (t3) t3.textContent = 'Ships on or before';
    } catch (eLab) {}
    if (step1) { step1.classList.add('is-now'); step1.classList.remove('is-next'); }
    if (step2) { step2.classList.add('is-next'); step2.classList.remove('is-now'); }
    if (step3) { step3.classList.remove('is-now', 'is-next'); }
    if (d1) d1.classList.add('is-active');
    if (d2) d2.classList.remove('is-active');
    if (d3) d3.classList.remove('is-active');
    return dates;
  }
  function paintShipProgressAll(){
    const cartRoot = document.getElementById('cartProgress');
    if (cartRoot) paintShipProgress(cartRoot);
    const pdpRoot = document.getElementById('pdpShipProgress');
    if (pdpRoot) paintShipProgress(pdpRoot);
    const ssrRoot = document.getElementById('ssrShipProgress');
    if (ssrRoot) paintShipProgress(ssrRoot);
  }

  function money(cents){
    const n = Number(cents);
    if (!isFinite(n)) return '$0';
    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }
  function cartSubtotalCents(c){
    if (!c) return 0;
    if (typeof c.items_subtotal_price === 'number') return c.items_subtotal_price;
    if (typeof c.total_price === 'number') return c.total_price;
    // Last resort: sum line prices
    return (c.items || []).reduce(function(s, it){
      return s + (Number(it.final_line_price) || Number(it.line_price) || 0);
    }, 0);
  }

  function inCart(variantId){
    if (!variantId || !state.cart) return false;
    return state.cart.items.some(it => it.variant_id === Number(variantId));
  }

  /** Cover line (not accessory) — free removable mags with every cover order */
  function isCoverItem(it){
    const sku = (it && it.sku) || '';
    if (sku && /^ACC-/i.test(sku)) return false;
    if (sku && /^(UTV|JP|RV)-/i.test(sku)) return true;
    // Fallback: product type / title when SKU missing
    const t = ((it && it.product_title) || '') + ' ' + ((it && it.product_type) || '');
    return /windshield|cover/i.test(t) && !/magnet|cleaner|warranty|pad/i.test(t);
  }
  function hasCoverItem(cart){
    return !!(cart && cart.items && cart.items.some(isCoverItem));
  }
  function toggleGiftStrip(el, on){
    if (!el) return;
    if (on) {
      el.classList.add('show');
      el.removeAttribute('hidden');
    } else {
      el.classList.remove('show');
      el.setAttribute('hidden', '');
    }
  }

  function render(){
    const pane = document.getElementById('cartItems');
    const count = document.getElementById('cartCount');
    const headCount = document.getElementById('cartHeadCount');
    const subtotal = document.getElementById('cartSubtotal');
    const totalEl = document.getElementById('cartTotal');
    const c = state.cart;
    if (!c) return;
    // Prefer live sum of current lines so UI never shows a stale total after remove
    const items = Array.isArray(c.items) ? c.items : [];
    const liveCount = items.reduce(function(n, it){ return n + (Number(it.quantity) || 0); }, 0);
    const liveSub = items.reduce(function(s, it){
      return s + (Number(it.final_line_price) || Number(it.line_price) || 0);
    }, 0);
    const itemCount = (typeof c.item_count === 'number' ? c.item_count : liveCount);
    const subCents = cartSubtotalCents(c);
    // If server total disagrees with line sum after a change, trust the line sum
    const displaySub = (items.length && liveSub > 0 && Math.abs(liveSub - subCents) > 1)
      ? liveSub
      : (subCents || liveSub);
    if (count) count.textContent = String(itemCount || liveCount || '0');
    if (headCount) headCount.textContent = String(itemCount || liveCount || '0');
    if (subtotal) subtotal.textContent = money(displaySub);
    if (totalEl) totalEl.textContent = money(typeof c.total_price === 'number' ? c.total_price : displaySub);

    // Ship progress — cart is the site standard (shared helper paints cart + every PDP)
    const hasCover = hasCoverItem(c);
    try { paintShipProgressAll(); } catch (eShip) {}
    try {
      const progSub = document.getElementById('cartProgSub');
      if (progSub) {
        progSub.hidden = true;
        progSub.textContent = hasCover
          ? 'Free shipping lower 48'
          : (c.item_count > 0
            ? 'Accessories ship at standard rates · free ship when you add a cover'
            : 'Free shipping lower 48 on every cover');
      }
      const legacyPct = document.getElementById('cartProgPct');
      if (legacyPct) { legacyPct.textContent = ''; legacyPct.hidden = true; }
      const legacyLab = document.getElementById('cartProgLabel');
      if (legacyLab) { legacyLab.textContent = ''; legacyLab.hidden = true; }
    } catch (eLeg) {}

    // Never show free Mag Pads gift UI in the drawer (no strip / no fake line / no line notes)
    const giftStrip = document.getElementById('cartGiftStrip');
    toggleGiftStrip(giftStrip, false);

    // Upsell discipline (Apple-simple cart):
    // 1) LOXX swap for Mag UTV/Jeep only
    // 2) Else one soft accessory (cleaner)
    // 3) Never stack LOXX + warranty + pads + cleaner
    // 4) Do NOT upsell paid Removable Mag Pads when free gift already applies
    const upsellWrap = document.getElementById('cartUpsells');
    const loxxEl = document.getElementById('cartLoxxUpsell');
    const cleanerEl = document.getElementById('cartUpsell');
    const padsEl = document.getElementById('cartMagnetPads');
    const warrantyEl = document.getElementById('cartWarrantyUpsell');
    const hide = (el) => { if (el) el.style.display = 'none'; };
    hide(loxxEl); hide(cleanerEl); hide(padsEl); hide(warrantyEl);
    if (upsellWrap) upsellWrap.style.display = 'none';

    if (c.item_count > 0){
      // Mag UTV/Jeep SKUs ending -BK/-CF (not -LX) → All-LOXX +$45 upgrade
      const swappable = c.items.some(it => it.sku && /^(UTV|JP)-/.test(it.sku) && /-(BK|CF)$/.test(it.sku) && !/-(CF-)?LX$/i.test(it.sku));
      let showUpsell = false;
      if (loxxEl && swappable && UP.loxxUpgrade && !inCart(UP.loxxUpgrade)){
        loxxEl.style.display = '';
        showUpsell = true;
      }
      // Soft accessories after cover is in cart (not part of Mag/LOXX configure)
      if (cleanerEl && UP.cleaner && !inCart(UP.cleaner) && hasCover){
        cleanerEl.style.display = '';
        showUpsell = true;
      }
      if (warrantyEl && UP.warranty && !inCart(UP.warranty) && hasCover){
        warrantyEl.style.display = '';
        showUpsell = true;
      }
      if (padsEl && UP.magnetPads && !inCart(UP.magnetPads) && hasCover && !swappable){
        // optional removable pads — only when not already promoting Mag free-pad story
        padsEl.style.display = '';
        showUpsell = true;
      }
      if (upsellWrap && showUpsell) upsellWrap.style.display = '';
    }

    if (!pane) return;
    if (!items.length){
      pane.innerHTML = '<p style="padding:40px;text-align:center;color:var(--muted)">Your cart is empty.</p>';
      return;
    }
    pane.innerHTML = items.map((it, idx) => {
      const props = it.properties || {};
      // Hide gift / internal props — no free Mag Pads spam in the drawer
      const propKeys = Object.keys(props).filter(k => {
        if (props[k] == null || !String(props[k]).length) return false;
        if (k.charAt(0) === '_') return false;
        if (/gift/i.test(k)) return false;
        if (/mag\s*pad|removable\s*mag/i.test(k + ' ' + String(props[k]))) return false;
        return true;
      });
      const propHtml = propKeys.length ? `<div style="margin-top:6px;font-size:11.5px;line-height:1.45;color:var(--slate-700)">${propKeys.map(k => {
        const val = String(props[k]);
        const isUrl = /^https?:\/\//i.test(val);
        const isPhoto = /^photo\s*\d/i.test(k) || /photo links/i.test(k);
        if (isUrl && (isPhoto || /^https?:\/\//i.test(val))) {
          return `<div><b>${k}:</b> <a href="${val}" target="_blank" rel="noopener" style="color:var(--bluestone-700);word-break:break-all">${isPhoto ? 'View photo ↗' : val}</a></div>`;
        }
        if (/photo links/i.test(k) && val.indexOf('http') !== -1) {
          const links = val.split(/\s*\|\s*/).filter(u => /^https?:\/\//i.test(u));
          return `<div><b>${k}:</b> ${links.map((u,i) => `<a href="${u}" target="_blank" rel="noopener" style="color:var(--bluestone-700)">Photo ${i+1} ↗</a>`).join(' · ')}</div>`;
        }
        return `<div><b>${k}:</b> ${val.length > 120 ? val.slice(0, 120) + '…' : val}</div>`;
      }).join('')}</div>` : '';
      const lineKey = it.key ? String(it.key).replace(/"/g, '&quot;') : '';
      const linePrice = Number(it.final_line_price) || Number(it.line_price) || 0;
      return `
      <div class="cart-item" data-line="${idx+1}" data-key="${lineKey}" data-variant-id="${it.variant_id || it.id || ''}">
        <a href="${it.url || '#'}" style="flex-shrink:0"><img src="${it.image || ''}" alt="" style="width:72px;height:72px;object-fit:cover;border-radius:8px;background:var(--bone)"></a>
        <div style="min-width:0;overflow:hidden">
          <a href="${it.url || '#'}" style="color:inherit;text-decoration:none"><div style="font-weight:600;font-size:14px;line-height:1.3;overflow-wrap:anywhere;word-break:break-word">${it.product_title || 'Item'}</div></a>
          <div style="color:var(--muted);font-size:12px;overflow-wrap:anywhere">${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''}</div>
          ${it.sku ? `<div style="color:var(--muted);font-size:10.5px;letter-spacing:.05em;margin-top:2px">${it.sku}</div>` : ''}
          ${propHtml}
          <div style="display:flex;align-items:center;flex-wrap:wrap;gap:8px 12px;margin-top:8px">
            <div class="qty-stepper small">
              <button type="button" data-act="minus" aria-label="Decrease quantity">−</button>
              <span data-qty>${it.quantity}</span>
              <button type="button" data-act="plus" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" data-act="remove" style="background:none;border:0;color:var(--muted);font-size:12px;cursor:pointer;text-decoration:underline;white-space:nowrap;flex-shrink:0">Remove</button>
          </div>
        </div>
        <div style="font-weight:700;flex-shrink:0" data-line-price>${money(linePrice)}</div>
      </div>`;
    }).join('');
  }

  function openCart(force){
    /* PDP Checkout CTA briefly sets __fitSkipCartOpen so add→checkout never flashes the drawer.
       Header cart / explicit user open always wins (force or skip window expired). */
    try {
      if (!force && window.__fitSkipCartOpen) {
        var until = window.__fitSkipCartUntil || 0;
        if (until && Date.now() < until) return;
        window.__fitSkipCartOpen = false;
      }
      if (force) {
        window.__fitSkipCartOpen = false;
        window.__fitSkipCartUntil = 0;
      }
    } catch (e0) {}
    var d = document.getElementById('cartDrawer');
    var o = document.getElementById('cartOverlay');
    if (!d) {
      try { window.location.href = '/cart'; } catch (eLoc) {}
      return;
    }
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    /* Never use inert — it blocks scroll + checkout on iOS/Safari */
    d.removeAttribute('inert');
    d.style.pointerEvents = 'auto';
    d.style.zIndex = '10050';
    if (o) {
      o.classList.add('open');
      o.style.zIndex = '10040';
      o.style.pointerEvents = 'auto';
    }
    try { document.body.style.overflow = 'hidden'; } catch (eB) {}
    try { refresh(); } catch (eR) {}
    try {
      var co = document.getElementById('cartCheckoutBtn');
      if (co) {
        co.style.pointerEvents = 'auto';
        setTimeout(function(){ try { co.focus({ preventScroll: true }); } catch (e) {} }, 150);
      }
    } catch (e2) {}
  }
  function closeCart(){
    var d = document.getElementById('cartDrawer');
    var o = document.getElementById('cartOverlay');
    if (d) {
      d.classList.remove('open');
      d.setAttribute('aria-hidden', 'true');
      d.removeAttribute('inert');
    }
    if (o) o.classList.remove('open');
    try { document.body.style.overflow = ''; } catch (eB) {}
  }
  async function checkout(){
    // Best-effort attr stamp, then always leave for /checkout (never hang on network)
    var done = false;
    function go(){
      if (done) return;
      done = true;
      window.location.href = '/checkout';
    }
    setTimeout(go, 900); // hard fallback if fetch stalls
    try {
      const c = state.cart || await refresh();
      const prev = (c && c.attributes) || {};
      const attrs = Object.assign({}, prev, {
        'Ship promise': 'Ships within 5 business days'
      });
      try {
        if (typeof window.__fitPersistGoogleClickIds === 'function') {
          window.__fitPersistGoogleClickIds();
        }
        const cookie = (n) => {
          try {
            const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + n + '=([^;]*)'));
            return m ? decodeURIComponent(m[1]) : '';
          } catch (e0) { return ''; }
        };
        const gclid = cookie('_ra_gclid') || cookie('gclid') || prev.gclid || prev._ra_gclid || '';
        const gbraid = cookie('_ra_gbraid') || prev.gbraid || prev._ra_gbraid || '';
        const wbraid = cookie('_ra_wbraid') || cookie('wbraid') || prev.wbraid || prev._ra_wbraid || '';
        if (gclid) { attrs._ra_gclid = gclid; attrs.gclid = gclid; }
        if (gbraid) { attrs._ra_gbraid = gbraid; attrs.gbraid = gbraid; }
        if (wbraid) { attrs._ra_wbraid = wbraid; attrs.wbraid = wbraid; }
      } catch (e1) {}
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        credentials: 'same-origin',
        keepalive: true
      });
    } catch (e) { /* never block checkout */ }
    go();
  }

  // Checkout button — always navigate; stamp attrs in parallel
  document.addEventListener('click', function(e){
    const a = e.target && e.target.closest && e.target.closest('#cartCheckoutBtn, a.cart-checkout');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    checkout();
  }, true);

  document.addEventListener('click', async (e) => {
    try {
      const t = e.target;
      if (t.matches('[data-cart-open]') || t.closest('[data-cart-open]')){ e.preventDefault(); openCart(true); return; }
      if (t.matches('[data-cart-close]') || t.closest('[data-cart-close]')){ e.preventDefault(); closeCart(); return; }
      const actBtn = t.closest && t.closest('[data-act]');
      const row = t.closest && t.closest('.cart-item');
      if (!row || !actBtn) return;
      e.preventDefault();
      e.stopPropagation();
      if (state.busy) return;
      if (!state.cart || !state.cart.items) { try { await refresh(); } catch (eR) { return; } }
      const line = parseInt(row.getAttribute('data-line'), 10);
      const key = row.getAttribute('data-key') || '';
      // Prefer matching by line-item key so same-variant lines don't get confused
      let item = null;
      let lineNum = line;
      if (key && state.cart.items) {
        const idx = state.cart.items.findIndex(function(it){ return String(it.key) === key; });
        if (idx >= 0) { item = state.cart.items[idx]; lineNum = idx + 1; }
      }
      if (!item) item = state.cart.items[line - 1] || null;
      if (!item) { await refresh(); return; }
      const act = actBtn.getAttribute('data-act');
      state.busy = true;
      try {
        if (act === 'plus') await changeItem(lineNum, (item.quantity || 1) + 1);
        else if (act === 'minus') await changeItem(lineNum, Math.max(0, (item.quantity || 1) - 1));
        else if (act === 'remove') await changeItem(lineNum, 0);
        // Always re-sync from server so subtotal can't stay on the old total
        await refresh();
      } finally {
        state.busy = false;
      }
    } catch (err) {
      state.busy = false;
      try { console.warn('cart click', err); } catch (e2) {}
      try { await refresh(); } catch (e3) {}
    }
  });

  // LOXX cart upsell: swap the cover line to its real -LX variant so the order
  // books as one LOXX cover SKU (production reads the SKU). Only falls back to
  // the standalone $49 upgrade line when no LX variant exists for that cover.
  async function addLoxxUpgrade(){
    const c = state.cart || await refresh();
    const cover = (c.items || []).find(it => it.sku && /^(UTV|JP)-/.test(it.sku) && /-(BK|CF)$/.test(it.sku));
    if (cover){
      let lxSku = null;
      if (/-BK$/.test(cover.sku)) lxSku = cover.sku.replace(/-BK$/, '-LX');
      else if (/-CF$/.test(cover.sku)) lxSku = cover.sku + '-LX';
      if (lxSku){
        try {
          const p = await (await fetch('/products/' + cover.handle + '.js', { headers: { Accept: '*/*' } })).json();
          const lx = (p.variants || []).find(v => v.sku === lxSku);
          if (lx && lx.available !== false){
            const line = c.items.indexOf(cover) + 1;
            const q = cover.quantity;
            const props = cover.properties || {};
            await changeItem(line, 0);
            await addItem(lx.id, q, props);
            return;
          }
        } catch(e){ /* fall through to standalone upgrade line */ }
      }
    }
    addItem(UP.loxxUpgrade);
  }

  window.FIT = {
    openCart, closeCart, addItem, addItems, trackAddToCart, checkout, refresh,
    addUpsell(){ addItem(UP.cleaner); },
    addMagnetPads(){ addItem(UP.magnetPads); },
    addWarranty(){ addItem(UP.warranty); },
    addLifetime(){ addItem(UP.lifetime); },
    addLoxxKit(){ addItem(UP.loxxKit); },
    addLoxxUpgrade,
    /* Cart-standard ship timeline for PDP / SSR / any page */
    shipProgressDates,
    paintShipProgress,
    paintShipProgressAll
  };
  function bootShipProgress(){
    try { paintShipProgressAll(); } catch (e0) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootShipProgress);
  else bootShipProgress();
  setTimeout(bootShipProgress, 50);
  setTimeout(bootShipProgress, 400);
  document.addEventListener('DOMContentLoaded', refresh);

  /* Header announce marquee — page_cache can freeze old static bar; rehydrate section */
  (function rehydrateHeaderAnnounce(){
    try {
      if (window.__FIT_HEADER_ANNOUNCE_LIVE) return;
      var html = document.documentElement.innerHTML || '';
      if (html.indexOf('fit-header-announce:marquee-usa-warranty') !== -1 && html.indexOf('fitAnnounceScroll') !== -1) return;
      var target = document.getElementById('shopify-section-header-v2');
      if (!target) return;
      window.__FIT_HEADER_ANNOUNCE_LIVE = true;
      var path = location.pathname || '/';
      /* Avoid /?sections= (IndexController page_cache); product/collection paths return fresh */
      var base = /^\/(products|collections|pages)\//.test(path) ? path : '/collections/shop-utv-new';
      var url = base + (location.search && base === path ? (location.search + '&') : '?') + 'sections=header-v2';
      if (base !== path) url = base + '?sections=header-v2';
      fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: '*/*' } })
        .then(function(r){ return r.json(); })
        .then(function(data){
          var fresh = data && data['header-v2'];
          if (!fresh || fresh.indexOf('fitAnnounceScroll') === -1) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = fresh;
          var el = tmp.firstElementChild || tmp;
          target.replaceWith(el);
          /* re-bind mobile drawer after header replace */
          try {
            var btn = document.getElementById('navMobileBtn');
            var drawer = document.getElementById('mobileNavDrawer');
            if (btn && drawer && !btn.__fitBound) {
              btn.__fitBound = true;
              btn.addEventListener('click', function(){
                var open = drawer.classList.toggle('open');
                drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
              });
              drawer.querySelectorAll('[data-close]').forEach(function(el2){
                el2.addEventListener('click', function(){
                  drawer.classList.remove('open');
                  drawer.setAttribute('aria-hidden', 'true');
                });
              });
            }
          } catch (eBind) {}
          document.body.setAttribute('data-fit-header-announce', 'marquee-live');
        })
        .catch(function(){ window.__FIT_HEADER_ANNOUNCE_LIVE = false; });
    } catch (e) {}
  })();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ try { /* re-run if needed */ } catch (e0) {} });
  setTimeout(function(){
    try {
      if (document.documentElement.innerHTML.indexOf('fitAnnounceScroll') === -1) {
        window.__FIT_HEADER_ANNOUNCE_LIVE = false;
        /* second pass */
        var t = document.getElementById('shopify-section-header-v2');
        if (t && !document.body.getAttribute('data-fit-header-announce')) {
          /* function already ran once; allow retry by clearing flag before re-invoke not available — fetch inline */
          fetch('/collections/shop-utv-new?sections=header-v2', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: '*/*' } })
            .then(function(r){ return r.json(); })
            .then(function(data){
              var fresh = data && data['header-v2'];
              var target = document.getElementById('shopify-section-header-v2');
              if (!fresh || !target || fresh.indexOf('fitAnnounceScroll') === -1) return;
              var tmp = document.createElement('div');
              tmp.innerHTML = fresh;
              target.replaceWith(tmp.firstElementChild || tmp);
              document.body.setAttribute('data-fit-header-announce', 'marquee-live');
            }).catch(function(){});
        }
      }
    } catch (e1) {}
  }, 600);
})();

/* ===== Mobile: body padding when fixed bottom bars are visible (sticky CTA / ATC) ===== */
(function(){
  function syncStickyPad(){
    try {
      var sticky = document.querySelector('.sticky-mobile-cta.visible, #home-sticky-cta.visible');
      var atc = document.querySelector('.mobile-atc-bar');
      var cfg = document.getElementById('cfgStickyBar');
      var atcOn = atc && window.getComputedStyle(atc).display !== 'none';
      var cfgOn = cfg && !cfg.hidden && window.getComputedStyle(cfg).display !== 'none';
      // PDP / custom-fit already pad via their own body classes — still flag for shared CSS
      if (sticky || atcOn || cfgOn) document.body.classList.add('has-sticky-cta');
      else document.body.classList.remove('has-sticky-cta');
    } catch (e) {}
  }
  function boot(){
    syncStickyPad();
    var sticky = document.getElementById('stickyCta') || document.querySelector('.sticky-mobile-cta');
    if (sticky && window.MutationObserver){
      new MutationObserver(syncStickyPad).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    }
    var cfg = document.getElementById('cfgStickyBar');
    if (cfg && window.MutationObserver){
      new MutationObserver(syncStickyPad).observe(cfg, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    }
    window.addEventListener('scroll', syncStickyPad, { passive: true });
    window.addEventListener('resize', syncStickyPad, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ===== Video modal — [data-yt-modal] opens local mp4 or YouTube id; [data-yt-portrait] for vertical ===== */
(function(){
  let modal = null;
  /* Inject layout CSS if theme CSS is stale/cached without .yt-modal (audio-only bug) */
  function ensureYtCss(){
    if (document.getElementById('fit-yt-modal-css')) return;
    try {
      var probe = document.createElement('div');
      probe.className = 'yt-modal';
      probe.style.cssText = 'position:absolute;left:-9999px;visibility:hidden';
      document.body.appendChild(probe);
      var cs = window.getComputedStyle(probe);
      var ok = cs.position === 'fixed' || cs.zIndex === '1100' || cs.zIndex === '1000';
      probe.remove();
      if (ok) return;
    } catch (e0) {}
    var s = document.createElement('style');
    s.id = 'fit-yt-modal-css';
    s.textContent =
      '.yt-modal{position:fixed;inset:0;z-index:1100;display:none;align-items:center;justify-content:center;padding:32px;pointer-events:none}'+
      '.yt-modal.open{display:flex!important;pointer-events:auto}'+
      '.yt-modal-backdrop{position:absolute;inset:0;background:rgba(8,11,14,.88);backdrop-filter:blur(6px)}'+
      '.yt-modal-dialog{position:relative;width:min(1040px,100%);z-index:1}'+
      '.yt-modal-frame{position:relative;width:100%;aspect-ratio:16/9;background:#000;border-radius:16px;overflow:hidden;box-shadow:0 30px 90px rgba(0,0,0,.6)}'+
      '.yt-modal-frame.portrait{aspect-ratio:9/16;width:min(400px,92vw);margin:0 auto}'+
      '.yt-modal-frame iframe,.yt-modal-frame video{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;border:0!important;object-fit:contain;background:#000;display:block}'+
      '.yt-modal-close{position:absolute;top:-14px;right:-14px;width:44px;height:44px;border-radius:50%;background:#F4F1EC;color:#141C23;border:none;display:grid;place-items:center;cursor:pointer;z-index:2;padding:0;box-shadow:0 6px 20px rgba(0,0,0,.4)}'+
      '@media (max-width:640px){.yt-modal{padding:16px}.yt-modal-close{top:-10px;right:0}}';
    (document.head || document.documentElement).appendChild(s);
  }
  function ensureModal(){
    ensureYtCss();
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'ytModal';
    modal.className = 'yt-modal';
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML =
      '<div class="yt-modal-backdrop" data-yt-close></div>'+
      '<div class="yt-modal-dialog">'+
        '<button type="button" class="yt-modal-close" data-yt-close aria-label="Close video">'+
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'+
        '</button>'+
        '<div class="yt-modal-frame" role="dialog" aria-modal="true" aria-label="Video player"></div>'+
      '</div>';
    document.body.appendChild(modal);
    const frame = modal.querySelector('.yt-modal-frame');
    const close = () => {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden','true');
      try {
        frame.querySelectorAll('video').forEach(function(v){ try { v.pause(); } catch (e) {} });
      } catch (e1) {}
      frame.innerHTML = '';
      document.documentElement.style.overflow = '';
      try { document.body.style.overflow = ''; } catch (e2) {}
    };
    modal.addEventListener('click', e => { if (e.target.closest('[data-yt-close]')) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
    const mediaCss = 'position:absolute;inset:0;width:100%;height:100%;border:0;object-fit:contain;background:#000;display:block';
    const buildYT = (ytId) => {
      const ifr = document.createElement('iframe');
      ifr.src = 'https://www.youtube-nocookie.com/embed/' + ytId + '?rel=0&autoplay=1&playsinline=1&modestbranding=1';
      ifr.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      ifr.setAttribute('allowfullscreen', '');
      ifr.allowFullscreen = true;
      ifr.title = 'FIT Protection video';
      ifr.style.cssText = mediaCss;
      ifr.setAttribute('frameborder', '0');
      return ifr;
    };
    modal._open = (id, portrait) => {
      ensureYtCss();
      frame.classList.toggle('portrait', !!portrait);
      frame.innerHTML = '';
      if (!id) return;
      // Normalize protocol-relative CDN URLs so <video> always loads on https
      let src = String(id).trim();
      if (src.indexOf('//') === 0) src = 'https:' + src;
      const isYtId = /^[\w-]{6,20}$/.test(src) && src.indexOf('.') === -1 && src.indexOf('/') === -1;
      const isFile = !isYtId && (/\.(mp4|webm|mov)(\?|#|$)/i.test(src) || /\/cdn\/|\.myshopify\.com\//i.test(src) || /fitprotection\.com\/cdn\//i.test(src));
      if (isFile){
        const vid = document.createElement('video');
        vid.src = src;
        vid.controls = true; vid.autoplay = true; vid.playsInline = true; vid.muted = false;
        vid.setAttribute('playsinline','');
        vid.setAttribute('webkit-playsinline','');
        vid.setAttribute('preload','auto');
        vid.style.cssText = mediaCss;
        // If local mp4 fails, fall back to known YouTube hold-test
        vid.addEventListener('error', () => {
          try {
            frame.innerHTML = '';
            frame.appendChild(buildYT('TV7gO41VEz0'));
          } catch (e) {}
        }, { once: true });
        frame.appendChild(vid);
        vid.play().catch(()=>{});
      } else if (isYtId || src){
        const ytId = isYtId ? src : src;
        frame.appendChild(buildYT(ytId));
      }
      modal.classList.add('open');
      modal.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow = 'hidden';
      try { document.body.style.overflow = 'hidden'; } catch (e3) {}
    };
    modal._close = close;
    return modal;
  }
  document.addEventListener('click', e => {
    const el = e.target.closest('[data-yt-modal]');
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    ensureModal()._open(el.getAttribute('data-yt-modal'), el.hasAttribute('data-yt-portrait'));
  }, true);
})();

/* Mobile/tablet only: pin journey hero. Desktop uses hero-desktop-column.jpg from CSS. */
(function forceMobileJourneyHero(){
  function apply(){
    if(!document.body||!document.body.classList.contains("index-body")) return;
    if(document.getElementById("fit-hero-mobile-journey-js")) return;
    var s=document.createElement("style");
    s.id="fit-hero-mobile-journey-js";
    s.textContent="@media (max-width:900px){.hero-visual::before{background-image:url('https://fitprotection.com/cdn/shop/t/102/assets/hero-loxx-mobile-banner.jpg')!important;background-size:cover!important;background-position:center 38%!important;background-repeat:no-repeat!important}}";
    (document.head||document.documentElement).appendChild(s);
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",apply);
  else apply();
})();



/* shield-only: never inject FIT wordmark into header logo */
(function(){
  function strip(){
    try{
      document.querySelectorAll('a.logo.logo-home .logo-home-word, a.logo.logo-home > span').forEach(function(el){ el.remove(); });
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',strip); else strip();
  setTimeout(strip,200);
})();

/* Sticky mobile CTA: single Find My Cover on homepage */
(function(){
  function fixHomeShell(){
    try {
      if (!document.body) return;
      var path = (location.pathname || '/').replace(/\/+$/, '') || '/';
      if (path !== '/') return;
      var sticky = document.getElementById('stickyCta');
      if (!sticky) return;
      var inner = sticky.querySelector('.sticky-mobile-cta-inner') || sticky;
      inner.classList.add('sticky-single');
      var secondary = sticky.querySelector('a.s-secondary');
      if (secondary) secondary.remove();
      var primary = sticky.querySelector('a.s-primary') || sticky.querySelector('a');
      if (primary) {
        primary.id = primary.id || 'stickyFindCover';
        primary.setAttribute('href', '#fitment');
        primary.innerHTML = 'Find My Cover <span aria-hidden="true">→</span>';
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixHomeShell);
  else fixHomeShell();
  setTimeout(fixHomeShell, 200);
})();

/* Fitment Find button: always tappable; incomplete → open Brand/Model */
(function(){
  function openSelect(sel){
    if (!sel) return;
    try {
      sel.focus({ preventScroll: false });
      if (typeof sel.showPicker === 'function') sel.showPicker();
    } catch (e) {
      try { sel.focus(); } catch (e2) {}
    }
  }
  function guideFind(){
    var brand = document.getElementById('fitBrand');
    var model = document.getElementById('fitModel');
    var hint = document.getElementById('fitHint');
    if (hint) {
      hint.textContent = 'Tap Brand, then Model — then Configure appears.';
      hint.classList.add('show');
    }
    if (brand && !brand.value) openSelect(brand);
    else if (model) openSelect(model);
    else if (brand) openSelect(brand);
  }
  function patch(){
    try {
      var btn = document.getElementById('fitFindBtn');
      if (btn) {
        btn.style.setProperty('pointer-events', 'auto', 'important');
        btn.style.setProperty('cursor', 'pointer', 'important');
        if (!btn.__fitFindPatched) {
          btn.__fitFindPatched = true;
          btn.addEventListener('click', function(e){
            var blocked = btn.classList.contains('is-blocked') || btn.getAttribute('aria-disabled') === 'true';
            var href = (btn.getAttribute('href') || '');
            if (blocked || href === '#fitment' || href === '' || href === '#') {
              e.preventDefault();
              e.stopPropagation();
              guideFind();
            }
          }, true);
        }
      }
      var label = document.getElementById('fitBarLabel') || document.querySelector('.hero-fitment-label');
      if (label && !label.__fitLabelPatched) {
        label.__fitLabelPatched = true;
        label.style.cursor = 'pointer';
        label.addEventListener('click', function(e){
          e.preventDefault();
          guideFind();
        });
      }
      /* Model empty option label */
      var model = document.getElementById('fitModel');
      if (model && model.options && model.options[0] && !model.options[0].value) {
        if (model.options[0].textContent !== 'Model') model.options[0].textContent = 'Model';
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', patch);
  else patch();
  setTimeout(patch, 200);
  setTimeout(patch, 800);
})();


/* One-shot: replace stale homepage with live section (busts IndexController page_cache) */
(function(){
  var HOME_VER='v54-bs-rv-20260813';
  var SECS=['home-main-v55','home-main-v54','home-main-v53'];
  function isHome(){
    var p=(location.pathname||'/').replace(/\/+$/,'')||'/';
    return p==='/'||p==='/index';
  }
  function needs(){
    try{
      var html=document.documentElement.innerHTML||'';
      if(html.indexOf('data-bs-version="v55"')!==-1 && html.indexOf(HOME_VER)!==-1) return false;
      if(document.querySelector('.hero-visual-hit, .hero-visual-cta')) return true;
      if(document.querySelector('.hero-visual') && !document.querySelector('.hero-picture, picture.hero-picture, .hero-visual picture')) return true;
      if(html.indexOf('hero-loxx-mobile-banner')===-1 && document.querySelector('.hero-visual')) return true;
      if(html.indexOf('data-bs-version="v55"')===-1) return true;
      if(html.indexOf('rockwood-mini-lite-cover')===-1) return true;
      var el=document.getElementById('fitment');
      if(!el) return true;
      return (el.getAttribute('data-fit-home')||'')!==HOME_VER;
    }catch(e){ return true; }
  }
  function killHeroTap(){
    try{
      document.querySelectorAll('.hero-visual-hit, .hero-visual-cta').forEach(function(n){ n.remove(); });
    }catch(e){}
  }
  function runScripts(root){
    if(!root) return;
    root.querySelectorAll('script').forEach(function(old){
      var s=document.createElement('script');
      if(old.src){s.src=old.src;s.async=false;} else s.textContent=old.textContent||'';
      old.parentNode.replaceChild(s,old);
    });
  }
  function apply(html){
    if(!html||(html.indexOf('data-fit-home="'+HOME_VER+'"')===-1&&html.indexOf('data-bs-version="v55"')===-1&&html.indexOf('hero-loxx-mobile-banner')===-1)) return false;
    var target=document.querySelector('[id*="home_main_v53"]')||document.querySelector('[id*="home_main_v54"]')
      ||document.getElementById('shopify-section-home-main-v54')||document.getElementById('shopify-section-home-main-v53')||document.getElementById('shopify-section-home-main-v52')||document.getElementById('shopify-section-home-main-v51')||document.getElementById('shopify-section-home-main-v48')||document.getElementById('shopify-section-home-main-v47')
      ||document.getElementById('shopify-section-home-main-live')
      ||document.getElementById('shopify-section-home-main')
      ||(document.getElementById('fitment')&&document.getElementById('fitment').closest('[id^="shopify-section"]'))
      ||document.getElementById('MainContent');
    if(!target) return false;
    var tmp=document.createElement('div');
    tmp.innerHTML=html;
    var fresh=tmp.firstElementChild||tmp;
    if(target.id==='MainContent'){
      var old=target.querySelector('[id^="shopify-section"]')||target.firstElementChild;
      if(old) old.replaceWith(fresh); else target.prepend(fresh);
    } else {
      target.replaceWith(fresh);
    }
    runScripts(fresh);
    killHeroTap();
    document.body.setAttribute('data-fit-home-live', HOME_VER);
    return true;
  }
  function go(){
    try{
      killHeroTap();
      if(!isHome()||!needs()||window.__FIT_HOME_LIVE) return;
      window.__FIT_HOME_LIVE=true;
      var tries=SECS.slice();
      function attempt(){
        if(!tries.length){ window.__FIT_HOME_LIVE=false; return; }
        var sec=tries.shift();
        fetch('/index?sections='+encodeURIComponent(sec),{credentials:'same-origin',cache:'no-store'})
          .then(function(r){return r.json();})
          .then(function(data){
            var html=data&&data[sec];
            if(!html||!apply(html)) attempt();
          }).catch(function(){ attempt(); });
      }
      attempt();
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
  setTimeout(go,400);
  setTimeout(killHeroTap,0);
  setTimeout(killHeroTap,200);
})();

/* Custom-fit page_cache rehydrate — restores measure diagram + drops magnet-inside fields when FPC lags */
(function(){
  var CF_MARK = 'custom-measure-example';
  function isCustomFit(){
    return /\/pages\/custom-fit(?:-order|-request|-v2)?\/?$/.test(location.pathname || '');
  }
  function isStale(){
    try {
      var html = document.documentElement && document.documentElement.innerHTML || '';
      /* Missing red-line example, or stale magnet-inside measure fields (All-LOXX customs = outside only) */
      if (html.indexOf('custom-measure-example') === -1) return true;
      if (html.indexOf('name="in_top_w"') !== -1 || html.indexOf('name="in_bot_w"') !== -1 || html.indexOf('name="in_h"') !== -1) return true;
      if (html.indexOf('Inside width') !== -1 || html.indexOf('Inside height') !== -1) return true;
      if (html.indexOf('Inside measures') !== -1 || html.indexOf('Helps magnet placement') !== -1) return true;
      /* Need all 7 outside measures (center L→R, center B→T, both diagonals) */
      if (html.indexOf('all 7 measures') === -1) return true;
      if (html.indexOf('name="out_mid_w"') === -1 || html.indexOf('name="out_diag_tl_br"') === -1) return true;
      /* Old photo step still re-explains step-2 diagram */
      if (html.indexOf('same style as the diagram') !== -1) return true;
      return false;
    } catch (e) { return true; }
  }
  function runScripts(root){
    if (!root) return;
    root.querySelectorAll('script').forEach(function(old){
      var s = document.createElement('script');
      if (old.src) { s.src = old.src; s.async = false; }
      else s.textContent = old.textContent || '';
      old.parentNode.replaceChild(s, old);
    });
  }
  function go(){
    try {
      if (!isCustomFit() || !isStale() || window.__FIT_CUSTOM_REF_LIVE) return;
      window.__FIT_CUSTOM_REF_LIVE = true;
      var secId = null;
      var host = document.querySelector('[id^="shopify-section-template"]')
        || document.querySelector('#MainContent [id^="shopify-section"]');
      if (host && host.id) secId = host.id.replace(/^shopify-section-/, '');
      var keys = [];
      if (secId) keys.push(secId);
      keys.push('custom-fit-order');
      keys.push('custom-fit-page');
      var tries = keys.slice();
      function attempt(){
        if (!tries.length) return;
        var key = tries.shift();
        fetch('/pages/custom-fit-order?sections=' + encodeURIComponent(key), { credentials: 'same-origin', cache: 'no-store' })
          .then(function(r){ return r.json(); })
          .then(function(data){
            var html = data && (data[key] || data['custom-fit-order'] || data['custom-fit-page']);
            if (!html || html.indexOf('custom-measure-example') === -1) { attempt(); return; }
            var target = document.getElementById('shopify-section-' + key)
              || document.querySelector('#MainContent [id^="shopify-section"]')
              || document.getElementById('MainContent');
            if (!target) return;
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.firstElementChild || tmp;
            if (target.id === 'MainContent') {
              var old = target.querySelector('[id^="shopify-section"]') || target.firstElementChild;
              if (old) old.replaceWith(fresh); else target.prepend(fresh);
            } else {
              target.replaceWith(fresh);
            }
            runScripts(fresh);
            document.body.setAttribute('data-fit-custom-ref', CF_MARK);
          })
          .catch(function(){ attempt(); });
      }
      attempt();
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  setTimeout(go, 350);
  setTimeout(go, 1200);
})();

/* fit-shop-grid-fix is loaded from layout via asset_url — do not inject a second
   CDN URL here (Shopify.cdnHost already includes /cdn → double-path console errors). */

/* PDP rehydrate — only recover truly broken shells; never downgrade v21 → v18 */
(function(){
  var PDP_MARK = 'v21-rv-hero-featured';
  var SEC_KEYS = ['product-page-v21', 'product-page-v20', 'product-page-v19'];
  function isProduct(){
    return (document.body && document.body.getAttribute('data-template') === 'product')
      || /^\/products\//.test(location.pathname || '');
  }
  function isFullyHydrated(){
    try {
      if (document.getElementById('atcBtn') && (document.getElementById('retOpts') || document.getElementById('finishOpts'))) return true;
      if (document.querySelector('#pdpRoot .pdp-sections') && document.getElementById('atcBtn')) return true;
    } catch (e) {}
    return false;
  }
  function isBroken(){
    try {
      var html = document.documentElement.innerHTML || '';
      /* Page-cache froze pre-gallery filter v21 → force one section rehydrate
         (drops Mini-Micro / old *-hero* / UTV double hero packshots) */
      if (document.getElementById('pdpRoot')
          && html.indexOf('fit-pdp-cache-bust:v21') !== -1
          && html.indexOf('fit-pdp-cache-bust:v21-gallery-utv-onedup') === -1
          && !window.__FIT_PDP_GALLERY_REHYDRATED) {
        return true;
      }
      /* Never replace a live v21 configurator */
      if (isFullyHydrated()) return false;
      if (document.getElementById('pdpShipProgress') && document.getElementById('finishOpts')) return false;
      /* Stale page-cache: phantom missing-asset stubs on inbox/video media → force section rehydrate */
      if (/\/assets\/(?:acc-loxx-kit|acc-warranty|loxx-kf-|loxx-press-pull|product-warranty)[^"'?\s]*\?v=504\d+/i.test(html)
          && html.indexOf('fit-pdp-cache-bust:v21-gallery-utv-onedup') === -1) {
        return true;
      }
      /* Live v21 markers — leave alone (do not match strings that only appear inside recovery scripts) */
      if (html.indexOf('fit-pdp-cache-bust:v21-gallery-utv-onedup') !== -1) return false;
      if (html.indexOf('fit-pdp-cache-bust:v21') !== -1) return false;
      if (html.indexOf(PDP_MARK) !== -1 && document.getElementById('pdpRoot')) return false;
      /* Real Liquid error nodes (not JS source that mentions the phrase) */
      if (document.querySelector('.shopify-section .liquid-error, .shopify-section [class*="liquid"]')) return true;
      var main = document.getElementById('MainContent') || document.getElementById('pdpRoot');
      if (main) {
        var mt = main.textContent || '';
        if (mt.indexOf('Liquid error (sections') !== -1) return true;
        if (mt.indexOf('invalid url input') !== -1) return true;
      }
      /* Thin shell: has gallery reviews pattern but no buy path at all */
      if (document.getElementById('pdpRoot') && !document.getElementById('ssrAtc') && !document.getElementById('atcBtn') && !document.getElementById('finishOpts')) return true;
      return false;
    } catch (e) { return false; }
  }
  function runScripts(root){
    if (!root) return;
    root.querySelectorAll('script').forEach(function(old){
      var typ = (old.getAttribute('type') || '').toLowerCase();
      if (typ && typ !== 'text/javascript' && typ !== 'application/javascript' && typ !== 'module') return;
      try {
        var s = document.createElement('script');
        if (old.src) { s.src = old.src; s.async = false; }
        else s.textContent = old.textContent || '';
        if (typ) s.type = old.type;
        if (old.parentNode) old.parentNode.replaceChild(s, old);
      } catch (eR) {}
    });
  }
  function go(){
    try {
      if (!isProduct() || window.__FIT_PDP_LIVE_DONE || !isBroken()) return;
      window.__FIT_PDP_LIVE_DONE = true;
      var path = location.pathname || '/';
      var tries = SEC_KEYS.slice();
      function attempt(){
        if (!tries.length) return;
        var sec = tries.shift();
        var url = path + (path.indexOf('?') >= 0 ? '&' : '?') + 'view=&sections=' + encodeURIComponent(sec);
        fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': '*/*' } })
          .then(function(r){ return r.json(); })
          .then(function(data){
            var html = data && data[sec];
            if (!html || html.indexOf('pdpRoot') === -1) { attempt(); return; }
            if (html.indexOf('Liquid error (sections') !== -1 && html.indexOf('function loadPDP') === -1) { attempt(); return; }
            /* Prefer v21 when available */
            if (sec !== 'product-page-v21' && html.indexOf('fit-pdp-cache-bust:v21') === -1 && tries.length) {
              attempt();
              return;
            }
            if (isFullyHydrated()) return;
            var target = document.querySelector('#MainContent [id^="shopify-section-template"]')
              || document.querySelector('#MainContent [id*="product-page"]')
              || document.querySelector('#MainContent [id^="shopify-section"]');
            if (!target) { attempt(); return; }
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.firstElementChild || tmp;
            try {
              window.__fitPdpHydrated = false;
              window.__fitPdpHydrating = false;
              window.__FIT_PDP_V21_MAIN = false;
              window.__FIT_PDP_GALLERY_REHYDRATED = true;
            } catch (e0) {}
            target.replaceWith(fresh);
            runScripts(fresh);
            document.body.setAttribute('data-fit-pdp-live', PDP_MARK);
            try { if (window.__fitPdpBoot) window.__fitPdpBoot(); } catch (e1) {}
          })
          .catch(function(){ attempt(); });
      }
      attempt();
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  setTimeout(go, 80);
})();

/* Collection page_cache rehydrate: replace stale main section when storefront HTML lags theme */
(function(){
  function isCollection(){
    return /^\/collections\//.test(location.pathname||'');
  }
  function isWrongThemeHtml(){
    try {
      if (window.Shopify && Shopify.theme && String(Shopify.theme.id) === '185190351139') return true;
      var html = document.documentElement && document.documentElement.innerHTML || '';
      if (html.indexOf('/cdn/shop/t/98/') !== -1) return true;
      if (html.indexOf('"id":185190351139') !== -1) return true;
      return false;
    } catch (e) { return false; }
  }
  function isStale(){
    try {
      if (isWrongThemeHtml()) return true;
      var html = document.documentElement && document.documentElement.innerHTML || '';
      /* Exact buggy collection init only — not our head patch string */
      if (html.indexOf("querySelector('.col-stat:nth-of-type(3) .n').textContent") !== -1) return true;
      if (html.indexOf('function setText') === -1 && html.indexOf('id="shopGrid"') !== -1) return true;
      return false;
    } catch (e) { return false; }
  }
  function runScripts(root){
    if (!root) return;
    root.querySelectorAll('script').forEach(function(old){
      var s = document.createElement('script');
      if (old.src) { s.src = old.src; s.async = false; }
      else s.textContent = old.textContent || '';
      old.parentNode.replaceChild(s, old);
    });
  }
  function go(){
    try {
      if (!isCollection() || window.__FIT_COL_LIVE || !isStale()) return;
      var target = document.querySelector('#MainContent [id^="shopify-section-template"]')
        || document.querySelector('#MainContent [id^="shopify-section-"]')
        || document.querySelector('[id^="shopify-section-template"]');
      if (!target || !target.id) return;
      var key = target.id.replace(/^shopify-section-/, '');
      window.__FIT_COL_LIVE = true;
      var url = location.pathname + (location.search ? location.search + '&' : '?') + 'sections=' + encodeURIComponent(key);
      fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': '*/*' } })
        .then(function(r){ return r.json(); })
        .then(function(data){
          var html = data && data[key];
          if (!html || html.indexOf('function setText') === -1) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.firstElementChild || tmp;
          target.replaceWith(fresh);
          runScripts(fresh);
          document.body.setAttribute('data-fit-col-live', 'js-zero-err-20260804c');
        })
        .catch(function(){});
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
  setTimeout(go, 300);
})();

/* Cart / collection / any page: page_cache can freeze OLD theme HTML
   (t/98 · #185190351139 "FIT Protection LIVE") while admin live is #186810728739 (t/102).
   Empty ?view= bypasses that cache and re-renders on the live theme (verified). */
(function(){
  function wrong(){
    try {
      if (window.Shopify && Shopify.theme && String(Shopify.theme.id) === '185190351139') return true;
      var html = document.documentElement && document.documentElement.innerHTML || '';
      return html.indexOf('/cdn/shop/t/98/') !== -1 || html.indexOf('"id":185190351139') !== -1;
    } catch (e) { return false; }
  }
  function missingLiveApp(){
    try {
      /* Live theme id but layout still pointing at pre-v54 fit-app.js only */
      if (window.Shopify && Shopify.theme && String(Shopify.theme.id) === '186810728739') {
        var html = document.documentElement && document.documentElement.innerHTML || '';
        if (html.indexOf('fit-app-v54') === -1 && html.indexOf('fit-app.js') !== -1) return true;
      }
    } catch (e) {}
    return false;
  }
  function go(){
    try {
      if (window.__FIT_THEME_RELOAD_DONE) return;
      if (/[?&]view=/.test(location.search || '')) return; /* already on bypass; do not loop */
      if (!wrong() && !missingLiveApp()) return;
      var k = 'fit_theme_view_' + (location.pathname || '/');
      try {
        if (sessionStorage.getItem(k) === '1') return;
        sessionStorage.setItem(k, '1');
      } catch (e0) {}
      window.__FIT_THEME_RELOAD_DONE = true;
      var q = location.search || '';
      var u = location.pathname + (q ? q + '&' : '?') + 'view=' + (location.hash || '');
      location.replace(u);
    } catch (e1) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
  setTimeout(go, 50);
})();


/* Contact form assist */
(function(){
  try {
    if (!/\/pages\/contact/i.test(location.pathname||'')) return;
    if (window.__fitFormAssist || window.__fitFormAssistLoading) return;
    window.__fitFormAssistLoading = true;
    var s=document.createElement('script');
    s.src='/cdn/shop/t/102/assets/fit-form-assist.js?v=formassist1';
    s.async=true;
    (document.head||document.documentElement).appendChild(s);
  } catch(e){}
})();



/* fit-pdp-gallery-sanitize-v5 — drop junk only; NEVER strip model/featured hero for studio packshots
   v4 bug: hasPack && isVehiclePng removed card heroes then rewrote #galleryMain → studio flash */
(function(){
  function fileName(src){
    try { return String(src||'').split('?')[0].split('/').pop().toLowerCase(); } catch(e){ return ''; }
  }
  function baseKey(src){
    var n = fileName(src).replace(/\.(jpg|jpeg|png|webp|gif)$/i, '');
    n = n.replace(/_\d+x\d+$/i, '');
    n = n.replace(/-[a-f0-9]{6,}$/i, '');
    return n;
  }
  function isLoxx(n){ return /^loxx-card-/.test(n); }
  function isThumb(n){ return /^product-thumb-/.test(n); }
  function isPack(n){ return /-bk\.(jpg|jpeg|png|webp)$/.test(n) || (/^(utv|rv|jp)-/.test(n) && n.indexOf('hero')===-1 && !isThumb(n) && !isLoxx(n)); }
  function isHero(n){ return n.indexOf('hero') !== -1; }
  function isVehiclePng(n){ return /\.png$/.test(n) && !isThumb(n) && !isHero(n) && !isLoxx(n); }
  function featuredKey(){
    try {
      var f = (window.FIT_PDP && FIT_PDP.featuredImage) ? String(FIT_PDP.featuredImage) : '';
      return f ? baseKey(f) : '';
    } catch (e) { return ''; }
  }
  function sameFile(a, b){
    if (!a || !b) return false;
    if (a === b || a.split('?')[0] === b.split('?')[0]) return true;
    var ka = baseKey(a), kb = baseKey(b);
    return !!(ka && kb && ka === kb);
  }
  function fullFromThumb(th){
    if(!th) return '';
    var full=th.getAttribute('data-full');
    if(full) return full;
    var img=th.querySelector('img');
    var src=(img&&img.src)||'';
    return src ? src.replace(/([?&])width=\d+/i,'$1width=1000') : '';
  }
  function sanitize(force){
    try{
      var root=document.getElementById('galleryThumbs');
      if(!root) return;
      var stills=[].slice.call(root.querySelectorAll('.gallery-thumb[data-idx]'));
      if(!stills.length) return;
      // Already cleaned and nothing new — do not touch active state (that made thumbs feel dead)
      if(!force && root.dataset.fitSanitized==='v5' && !root.querySelector('.gallery-thumb[data-idx]:not([data-fit-kept])')){
        return;
      }
      var featK = featuredKey();
      var vehicleCount=0;
      var heroCount=0;
      var removed=false;
      stills.forEach(function(th){
        var img=th.querySelector('img');
        var full=th.getAttribute('data-full')||(img&&img.src)||'';
        var n=fileName(full);
        if(/logo-shield|placeholder|coming-soon|spacer|blank/.test(n)){ th.remove(); removed=true; return; }
        /* Keep ONE model / outdoor PNG (card/hero). Extra identity shots → double hero look. */
        if(isVehiclePng(n) && !isPack(n)){
          if(featK && baseKey(full) === featK){
            vehicleCount++;
            return; /* always keep featured */
          }
          vehicleCount++;
          if(vehicleCount > 1){ th.remove(); removed=true; return; }
          return;
        }
        if(isHero(n)){
          heroCount++;
          if(heroCount > 2){ th.remove(); removed=true; return; }
        }
      });
      var keep=[].slice.call(root.querySelectorAll('.gallery-thumb[data-idx]'));
      if(!keep.length) return;
      // Remember current selection (by full src) so reindex doesn't steal the click
      var prevActive=root.querySelector('.gallery-thumb[data-idx].active');
      var prevFull=prevActive ? fullFromThumb(prevActive) : '';
      var main=document.getElementById('galleryMain');
      var mainSrc=main ? (main.currentSrc||main.src||main.getAttribute('src')||'') : '';
      keep.forEach(function(th,i){
        th.setAttribute('data-idx', String(i));
        th.setAttribute('data-fit-kept','1');
      });
      // Prefer: previous active → current main → featured → first non-pack → 0
      var stillThere=prevFull && keep.some(function(th){ return sameFile(fullFromThumb(th), prevFull); });
      var pickIdx=0;
      if(stillThere){
        for(var i=0;i<keep.length;i++){
          if(sameFile(fullFromThumb(keep[i]), prevFull)){ pickIdx=i; break; }
        }
      } else if(mainSrc){
        var matchedMain=false;
        for(var j=0;j<keep.length;j++){
          if(sameFile(fullFromThumb(keep[j]), mainSrc)){ pickIdx=j; matchedMain=true; break; }
        }
        if(!matchedMain && featK){
          for(var k=0;k<keep.length;k++){
            if(baseKey(fullFromThumb(keep[k])) === featK){ pickIdx=k; matchedMain=true; break; }
          }
        }
        if(!matchedMain){
          for(var p=0;p<keep.length;p++){
            if(!isPack(fileName(fullFromThumb(keep[p])))){ pickIdx=p; break; }
          }
        }
      } else if(featK){
        for(var f=0;f<keep.length;f++){
          if(baseKey(fullFromThumb(keep[f])) === featK){ pickIdx=f; break; }
        }
      }
      // If user already chose a non-first image and we didn't remove anything structural, keep UI alone
      if(!force && root.dataset.fitSanitized==='v5' && !removed){
        return;
      }
      keep.forEach(function(th,i){
        var on=i===pickIdx;
        th.classList.toggle('active', on);
        th.setAttribute('aria-selected', on?'true':'false');
      });
      // Only rewrite main when selection was removed — never flash studio over an already-correct hero
      if(main && keep[pickIdx] && (force || removed || !mainSrc || !stillThere)){
        var src=fullFromThumb(keep[pickIdx]);
        if(src && !sameFile(src, mainSrc)){
          /* Do not replace a live featured/model hero with a studio packshot */
          var srcN=fileName(src), mainN=fileName(mainSrc);
          var mainIsIdentity = !!(mainSrc && (isVehiclePng(mainN) || (featK && baseKey(mainSrc)===featK) || !isPack(mainN)));
          var srcIsPack = isPack(srcN);
          if(!(mainIsIdentity && srcIsPack && mainSrc)){
            main.src=src;
            main.style.setProperty('object-fit','cover','important');
            main.style.setProperty('object-position','center center','important');
            main.style.setProperty('width','100%','important');
            main.style.setProperty('height','100%','important');
          }
        }
      }
      try{
        var dots=document.getElementById('galleryDots');
        if(dots && dots.children.length!==keep.length){
          dots.innerHTML=keep.map(function(_,i){ return '<span class="gallery-dot'+(i===pickIdx?' on':'')+'"></span>'; }).join('');
        }
      }catch(eD){}
      root.dataset.fitSanitized='v5';
      try{ document.dispatchEvent(new CustomEvent('fit:gallery-sanitized',{detail:{count:keep.length,pick:pickIdx}})); }catch(eE){}
    }catch(e){}
  }
  var t=null;
  function schedule(force){
    if(t) clearTimeout(t);
    t=setTimeout(function(){ sanitize(!!force); }, force?0:80);
  }
  function boot(){
    schedule(true);
    setTimeout(function(){ schedule(true); }, 120);
    setTimeout(function(){ schedule(false); }, 600);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  try{
    var mo=new MutationObserver(function(muts){
      var root=document.getElementById('galleryThumbs');
      if(!root) return;
      var relevant=muts.some(function(m){
        if(m.type!=='childList') return false;
        var nodes=[].concat([].slice.call(m.addedNodes),[].slice.call(m.removedNodes));
        return nodes.some(function(n){
          if(!n || n.nodeType!==1) return false;
          if(n.id==='galleryThumbs' || (n.classList&&n.classList.contains('gallery-thumb'))) return true;
          return !!(n.querySelector&&n.querySelector('.gallery-thumb,[id="galleryThumbs"]'));
        });
      });
      if(!relevant) return;
      if(root.dataset.fitSanitized!=='v5' || root.querySelector('.gallery-thumb[data-idx]:not([data-fit-kept])')){
        schedule(true);
      }
    });
    mo.observe(document.documentElement,{childList:true,subtree:true});
  }catch(e2){}
})();

// OUTSIDE_ONLY_MARK_20260806f


/* FIT_LOXX_UPGRADE_FORCE — page_cache may serve cover builder for ACC-LOXX-UPG */
(function(){
  if (window.__FIT_LOXX_UPGRADE_FORCE) return;
  window.__FIT_LOXX_UPGRADE_FORCE = true;
  if (!/\/products\/loxx-retention-upgrade\/?$/.test(location.pathname||'')) return;
  if (document.getElementById('loxxUpgradePdp') && !document.getElementById('retOpts')) return;
  function go(){
    if (document.getElementById('loxxUpgradePdp') && !document.getElementById('retOpts')) return;
    var path = location.pathname || '/';
    var url = path + '?sections=product-page-v21';
    fetch(url, { credentials:'same-origin', cache:'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html = data && data['product-page-v21'];
        if (!html || (html.indexOf('loxxUpgradePdp')===-1 && html.indexOf('loxx-upg')===-1)) return;
        var target = document.querySelector('#MainContent [id^="shopify-section-template"]')
          || document.querySelector('#MainContent [id^="shopify-section"]');
        if (!target) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.firstElementChild || tmp;
        target.replaceWith(fresh);
        fresh.querySelectorAll('script').forEach(function(old){
          var s=document.createElement('script');
          if (old.src){ s.src=old.src; s.async=false; }
          else s.textContent=old.textContent||'';
          if (old.parentNode) old.parentNode.replaceChild(s, old);
        });
        document.body.setAttribute('data-fit-loxx-upgrade','forced');
      }).catch(function(){});
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', go);
  else go();
  setTimeout(go, 200);
  setTimeout(go, 800);
})();

/**
 * fit-collection-filters.js — brand filters + ?brand= deep links
 * Survives CollectionController page_cache when section JS is stale.
 */
(function () {
  if (window.__FIT_COLLECTION_FILTERS_ASSET) return;
  window.__FIT_COLLECTION_FILTERS_ASSET = true;
  if (!/^\/collections\//.test(location.pathname || '')) return;

  function brandKey(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '');
  }
  function resolveBrandName(raw, brandNames) {
    if (!raw) return '';
    var want = brandKey(raw);
    var names = brandNames || [];
    for (var i = 0; i < names.length; i++) if (brandKey(names[i]) === want) return names[i];
    for (var j = 0; j < names.length; j++) {
      var k = brandKey(names[j]);
      if (k.indexOf(want) === 0 || want.indexOf(k) === 0) return names[j];
    }
    return raw;
  }

  function categoryFromPage() {
    var q = new URLSearchParams(location.search).get('cat');
    if (q) return q;
    var body = document.body;
    if (body) {
      if (body.getAttribute('data-cat')) return body.getAttribute('data-cat');
      var cls = body.className || '';
      if (/template-suffix-rv|collection-rv|shop-rvs/i.test(cls + ' ' + location.pathname)) return 'rv';
      if (/template-suffix-utv|collection-utv|shop-utv/i.test(cls + ' ' + location.pathname)) return 'utv';
      if (/vehicles/i.test(location.pathname)) return 'vehicles';
    }
    if (/shop-rvs|\/rv/i.test(location.pathname)) return 'rv';
    if (/vehicles/i.test(location.pathname)) return 'vehicles';
    return 'utv';
  }

  var CATEGORY = categoryFromPage();
  var active = { brands: new Set(), wipers: new Set(), prices: new Set() };
  var catalog = [];
  var POPULAR = [
    'polaris-ranger-xd',
    'can-am-defender-2016-2026-with-wiper',
    'can-am-maverick-x3',
    'cf-moto-uforce-u10',
    'polaris-general',
    '2018-2025-forest-river-rockwood-mini-lite-series',
    'fr-r-pod-190-series-flat-glass',
    'brinkley-i-275',
    'keystone-montana'
  ];

  function brandInActive(pBrand) {
    if (!active.brands.size) return true;
    var pk = brandKey(pBrand);
    var hit = false;
    active.brands.forEach(function (b) {
      if (brandKey(b) === pk) hit = true;
    });
    return hit;
  }

  function loadCatalog() {
    var all = window.FIT_CATALOG;
    if (!Array.isArray(all) || !all.length) return [];
    return all.filter(function (p) {
      return p && p.category === CATEGORY;
    });
  }

  function syncBrandUrl() {
    try {
      var u = new URL(location.href);
      if (active.brands.size === 1) u.searchParams.set('brand', active.brands.values().next().value);
      else u.searchParams.delete('brand');
      history.replaceState({}, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
  }

  function applyFilters(list) {
    return list.filter(function (p) {
      if (active.brands.size && !brandInActive(p.brand)) return false;
      if (active.wipers.size) {
        var hasW = /\(With Wiper\)/i.test(p.title || '');
        var noW = /\(Without Wiper\)/i.test(p.title || '');
        if (active.wipers.has('with') && !hasW) return false;
        if (active.wipers.has('without') && !noW) return false;
      }
      if (active.prices.size) {
        var inBucket = false;
        active.prices.forEach(function (b) {
          var parts = String(b).split('-').map(Number);
          if (!isNaN(parts[0]) && !isNaN(parts[1]) && p.price >= parts[0] && p.price < parts[1]) inBucket = true;
        });
        if (!inBucket) return false;
      }
      return true;
    });
  }

  function cardHtml(p, gi) {
    var img = p.mainImage || (p.images && p.images[0]) || '';
    var shortTitle = (p.title || '').replace(p.brand || '', '').trim() || p.title || '';
    var sold = p.soldOut === true;
    return (
      '<a href="/products/' +
      p.handle +
      '" class="product' +
      (sold ? ' is-sold-out' : '') +
      '" data-handle="' +
      p.handle +
      '">' +
      '<div class="img-wrap" style="position:relative;aspect-ratio:1/1;overflow:hidden">' +
      (img
        ? '<img src="' +
          img +
          '" alt="" loading="' +
          (gi < 4 ? 'eager' : 'lazy') +
          '" style="width:100%;height:100%;object-fit:contain">'
        : '') +
      (sold ? '<span class="badge sold-out">Sold Out</span>' : '') +
      '</div><div class="info"><div class="cat">' +
      (p.brand || '') +
      '</div><h3>' +
      shortTitle.replace(/</g, '&lt;') +
      '</h3><div class="foot"><div class="price"><span class="from">From</span> $' +
      Number(p.price || 0).toFixed(0) +
      '</div><span class="add">' +
      (sold ? 'Notify Me' : 'Configure') +
      ' →</span></div></div></a>'
    );
  }

  function render() {
    var grid = document.getElementById('shopGrid');
    if (!grid) return;
    var sortSel = document.getElementById('sortSel');
    var sort = sortSel ? sortSel.value : 'popular';
    var filtered = applyFilters(catalog.slice());
    if (sort === 'price-asc') filtered.sort(function (a, b) { return a.price - b.price; });
    else if (sort === 'price-desc') filtered.sort(function (a, b) { return b.price - a.price; });
    else if (sort === 'brand')
      filtered.sort(function (a, b) {
        return String(a.brand + a.title).localeCompare(String(b.brand + b.title));
      });
    else
      filtered.sort(function (a, b) {
        var ia = POPULAR.indexOf(a.handle);
        var ib = POPULAR.indexOf(b.handle);
        var ra = ia === -1 ? 999 : ia;
        var rb = ib === -1 ? 999 : ib;
        if (ra !== rb) return ra - rb;
        return String(a.brand + a.title).localeCompare(String(b.brand + b.title));
      });

    var rc = document.getElementById('resultCount');
    if (rc) rc.textContent = String(filtered.length);
    var applyBtn = document.getElementById('filterApplyBtn');
    if (applyBtn) applyBtn.textContent = filtered.length ? 'See ' + filtered.length + ' covers' : 'No matches — reset';

    document.querySelectorAll('#brandChips [data-chip-brand]').forEach(function (btn) {
      btn.classList.toggle('on', brandInActive(btn.getAttribute('data-chip-brand')));
    });

    if (!filtered.length) {
      grid.innerHTML =
        '<div class="shop-empty"><b>No matches</b><div style="margin-top:8px">Try clearing a filter, or <a href="/pages/custom-fit-order">request a custom fit</a>.</div><div style="margin-top:14px"><button type="button" class="filter-reset" id="fitFilterResetEmpty">Reset filters</button></div></div>';
      var emptyBtn = document.getElementById('fitFilterResetEmpty');
      if (emptyBtn) emptyBtn.addEventListener('click', resetFilters);
      return;
    }
    grid.innerHTML = filtered.map(cardHtml).join('');
  }

  function onFilterChange(e) {
    var cb = e.target;
    if (!cb || cb.type !== 'checkbox') return;
    var brand = cb.getAttribute('data-brand');
    var wiper = cb.getAttribute('data-wiper');
    var price = cb.getAttribute('data-price');
    if (brand) {
      if (cb.checked) active.brands.add(brand);
      else active.brands.delete(brand);
    }
    if (wiper) {
      if (cb.checked) active.wipers.add(wiper);
      else active.wipers.delete(wiper);
    }
    if (price) {
      if (cb.checked) active.prices.add(price);
      else active.prices.delete(price);
    }
    syncBrandUrl();
    render();
  }

  function resetFilters() {
    active.brands.clear();
    active.wipers.clear();
    active.prices.clear();
    document.querySelectorAll('.filter-group input[type=checkbox]').forEach(function (cb) {
      cb.checked = false;
    });
    document.querySelectorAll('#brandChips [data-chip-brand]').forEach(function (btn) {
      btn.classList.remove('on');
    });
    syncBrandUrl();
    render();
  }
  window.resetFilters = resetFilters;

  function init() {
    catalog = loadCatalog();
    if (!catalog.length) return false;
    if (!document.getElementById('shopGrid')) return false;

    var brandCounts = {};
    catalog.forEach(function (p) {
      if (!p.brand) return;
      brandCounts[p.brand] = (brandCounts[p.brand] || 0) + 1;
    });
    var brandNames = Object.keys(brandCounts).sort();
    var pre = resolveBrandName(new URLSearchParams(location.search).get('brand') || '', brandNames);

    var brandFiltersEl = document.getElementById('brandFilters');
    if (brandFiltersEl) {
      brandFiltersEl.innerHTML = brandNames
        .map(function (b) {
          return (
            '<label><input type="checkbox" data-brand="' +
            b.replace(/"/g, '&quot;') +
            '"' +
            (pre === b ? ' checked' : '') +
            '> ' +
            b +
            ' <span class="c">' +
            brandCounts[b] +
            '</span></label>'
          );
        })
        .join('');
    }

    active.brands.clear();
    if (pre) active.brands.add(pre);

    var chips = document.getElementById('brandChips');
    if (chips) {
      var top = brandNames.slice().sort(function (a, b) {
        return brandCounts[b] - brandCounts[a];
      }).slice(0, 8);
      chips.innerHTML =
        top
          .map(function (b) {
            return (
              '<button type="button" data-chip-brand="' +
              b.replace(/"/g, '&quot;') +
              '"' +
              (active.brands.has(b) ? ' class="on"' : '') +
              '>' +
              b +
              '<span class="c">' +
              brandCounts[b] +
              '</span></button>'
            );
          })
          .join('') + '<button type="button" data-chip-more="1">More brands ☰</button>';
      if (!chips.dataset.fitAssetBound) {
        chips.dataset.fitAssetBound = '1';
        chips.addEventListener('click', function (e) {
          var more = e.target.closest('[data-chip-more]');
          if (more) {
            var t = document.getElementById('filterToggleBtn');
            if (t) t.click();
            return;
          }
          var btn = e.target.closest('[data-chip-brand]');
          if (!btn) return;
          e.preventDefault();
          var brand = btn.getAttribute('data-chip-brand');
          var on = !btn.classList.contains('on');
          btn.classList.toggle('on', on);
          var box = document.querySelector('#brandFilters input[data-brand="' + brand.replace(/"/g, '') + '"]');
          if (box) box.checked = on;
          if (on) active.brands.add(brand);
          else active.brands.delete(brand);
          syncBrandUrl();
          render();
        });
      }
    }

    var filterCol = document.getElementById('filterCol');
    if (filterCol && !filterCol.dataset.fitAssetBound) {
      filterCol.dataset.fitAssetBound = '1';
      filterCol.addEventListener('change', onFilterChange);
    }
    var sortSel = document.getElementById('sortSel');
    if (sortSel && !sortSel.dataset.fitAssetBound) {
      sortSel.dataset.fitAssetBound = '1';
      sortSel.addEventListener('change', render);
    }

    var brandsEl = document.getElementById('countBrands');
    if (brandsEl) brandsEl.textContent = String(brandNames.length);
    var modelsEl = document.getElementById('countModels');
    if (modelsEl) {
      var bases = {};
      catalog.forEach(function (p) {
        if (p.modelBase) bases[p.modelBase] = 1;
      });
      modelsEl.textContent = String(Object.keys(bases).length);
    }

    render();
    document.body.setAttribute('data-fit-filters', 'asset-v1');
    return true;
  }

  function boot() {
    if (init()) return;
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (init() || n > 50) clearInterval(t);
    }, 100);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('fit-catalog-ready', function () {
    try {
      init();
    } catch (e) {}
  });
})();
;/* FIT_COL_GHOST_BOUNCE_R3 */
(function(){
  try{
    var path=(location.pathname||'');
    if(path.indexOf('/collections/')!==0)return;
    var html=document.documentElement&&document.documentElement.innerHTML||'';
    var frozen=html.indexOf('main_v11')!==-1||html.indexOf('fit-col-cache: card-reviews')!==-1;
    if(frozen && !/[?&]view=/.test(location.search||'')){
      var isRv=/shop-rvs|rv-covers|suffix-rv/i.test(path+' '+(document.body&&document.body.className||''));
      var u=new URL(location.href);
      u.searchParams.set('view', isRv?'rv-live':'utv-live');
      location.replace(u.pathname+u.search+u.hash);
      return;
    }
    if(!window.__FIT_COL_FILTERS_SRC){
      window.__FIT_COL_FILTERS_SRC=1;
      var s=document.createElement('script');
      s.src='https://cdn.shopify.com/s/files/1/0927/9605/9939/t/102/assets/fit-col-filters-v17d.js?v=bind-r3-20260817h';
      s.async=false;
      (document.head||document.documentElement).appendChild(s);
    }
    function rebind(){try{if(window.__fitColFiltersBind)window.__fitColFiltersBind(true)}catch(e){}}
    setTimeout(rebind,50);setTimeout(rebind,400);setTimeout(rebind,1200);setTimeout(rebind,2500);
  }catch(e){}
})();
